<template>
  <div id="container" class="col-12">
    <div id="TituloDetalleDeDocumento_div">
      <h2 class="label-black" style="margin-bottom: 0px;">Detalles de evaluaciones</h2>
    </div>
    <div class="row d-flex">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 padding-div-low" style="margin-top:0px;margin-bottom:0px;">
        <div class="area custom-area">
          <router-link to="/SIAP/SolicitudesEvaluacion">
            <button v-on:click="" id="btnAtras" class="btn btn-custom btn-sm">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i class="fas fa-arrow-left"></i> Atrás&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</button>
          </router-link>
          <div class="row">
            
            <div class="col-3" style="border-right:solid;padding-right:20px;">
              <br>
              <div class="row">
                <div class="col-12"><h6 class="label-black">Solicitud de Evaluación</h6></div>
              </div>
              <div class="row" style="margin-top:5px;margin-bottom:10px;">

                <div class="col-12">
                  <div class="row"><span class="col-form-label label-black"><b>ID Solicitud : </b>{{idSolicitud}}</span></div>
                  <div class="row"><span class="col-form-label label-black"><b>Estatus de la Solicitud : </b>{{EstatusSolicitud}}</span></div>
                  <div class="row"><span class="col-form-label label-black"><b>Fecha de Creación : </b>{{FechaCreacion}}</span></div>
                </div>
              </div>
            </div>
            <div class="col-9">
              <table class="table table-striped table-light table-hover" id="tablaEvaluaciones">
                <thead class="thead-custom">
                  <tr>
                    <th class="text-center">Id Evaluación</th>
                    <th class="text-center">Nombre del Evaluado</th>
                    <th class="text-center">Periodo de evaluación</th>
                    <th class="text-center">Fecha Límite</th>
                    <th class="text-center">Estatus de Evaluación</th>
                    <th class="text-center">Acciones</th>
                  </tr>
                </thead>
                <tbody class='text-dark'>
                  <tr v-for='evaluacion in evaluaciones'>
                    <td class="text-center">{{ evaluacion.EvaluacionId }}</td>
                    <td class="text-center">{{evaluacion.nombreEvaluado}}</td>
                    <td class="text-center">{{evaluacion.FechaInicioPeriodoEvaluacionString}} - {{evaluacion.FechaFinPeriodoEvaluacionString}}</td>
                    <td class="text-center">{{evaluacion.FechaLimiteEntregaString}}</td>
                    <td class="text-center">{{evaluacion.Estatus}}</td>
                    <td class='d-flex justify-content-around'>
                      <i class='fa fa-info-circle' @click="verDetalles(evaluacion.EvaluacionId)" />
                      <i class='fa fa-calendar' @click='editarPeriodoEvaluacion(evaluacion.EvaluacionId)' title="Editar Periodo de Evaluación" />
                      <i class='fa fa-trash' @click='pedirConfirmacion(evaluacion.EvaluacionId,evaluacion.nombreEvaluado)' title="Desactivar Solicitud de Evaluación" />

                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ModalConfirmacion titulo="titulo" cuerpo="cuerpo" ref="modalConfirmacion"></ModalConfirmacion>
    <!-- <div slot="title">
      <h2>Detalles de evaluaciones</h2>
    </div> -->
    <!-- <div slot="main">
      <div class="container-fluid">
        <router-link to="/SIAP/SolicitudesEvaluacion">
          <button v-on:click="" id="btnAtras" class="btn btn-primary"><i class="fas fa-arrow-left"></i> Atrás</button>
        </router-link>
        <hr>
        <div class="row">
          <div class="col-3" style="border-right:solid;padding-right:20px;">
            <div class="row">
              <div class="col-12"><h4><span class="col-form-label">Solicitud de Evaluación</span></h4></div>
            </div>
            <div class="row" style="margin-top:5px;margin-bottom:10px;">

              <div class="col-12">
                <div class="row"><span class="col-form-label"><b>ID Solicitud : </b>{{idSolicitud}}</span></div>
                <div class="row"><span class="col-form-label"><b>Estatus de la Solicitud : </b>{{EstatusSolicitud}}</span></div>
                <div class="row"><span class="col-form-label"><b>Fecha de Creación : </b>{{FechaCreacion}}</span></div>
              </div>
            </div>
          </div>
          <div class="col-9">
            <table class="table table-striped table-light table-hover" id="tablaEvaluaciones">
              <thead class="thead-custom">
                <tr>
                  <th class="text-center">Id Evaluación</th>
                  <th class="text-center">Nombre del Evaluado</th>
                  <th class="text-center">Periodo de evaluación</th>
                  <th class="text-center">Fecha Límite</th>
                  <th class="text-center">Estatus de Evaluación</th>
                  <th class="text-center">Acciones</th>
                </tr>
              </thead>
              <tbody class='text-dark'>
                <tr v-for='evaluacion in evaluaciones'>
                  <td class="text-center">{{ evaluacion.EvaluacionId }}</td>
                  <td class="text-center">{{evaluacion.nombreEvaluado}}</td>
                  <td class="text-center">{{evaluacion.FechaInicioPeriodoEvaluacionString}} - {{evaluacion.FechaFinPeriodoEvaluacionString}}</td>
                  <td class="text-center">{{evaluacion.FechaLimiteEntregaString}}</td>
                  <td class="text-center">{{evaluacion.Estatus}}</td>
                  <td class='d-flex justify-content-around'>
                    <i class='fa fa-info-circle' @click="verDetalles(evaluacion.EvaluacionId)" />
                    <i class='fa fa-calendar' @click='editarPeriodoEvaluacion(evaluacion.EvaluacionId)' title="Editar Periodo de Evaluación" />
                    <i class='fa fa-trash' @click='pedirConfirmacion(evaluacion.EvaluacionId,evaluacion.nombreEvaluado)' title="Desactivar Solicitud de Evaluación" />

                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
//import Layout from '@/components/SIAP/Comun/Plantilla.vue';
import catalogos from '@/../static/js/catalogos'
import comun from '@/../static/js/comun'
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import axios from 'axios'

  export default {
    props: ['idSolicitud'],
  data() {
      return {
        EstatusSolicitud: "Terminada",
        FechaCreacion: "02/10/2019",
        Solicitud: null,
        evaluaciones: [],
      IdEvaluacionSeleccionada: null
    }
  },
  components: {
    //Layout
    ModalConfirmacion: catalogos.SIAP.ModalConfirmacion
  },
    methods: {
      pedirConfirmacion: function (id,nombre) {
        var mensaje = "¿Está seguro de desactivar la de evaluación  de "+nombre+"?"
        var titulo = "Confirmación de desactivación"
        this.IdEvaluacionSeleccionada = id
        this.$refs.modalConfirmacion.mostrar(titulo, mensaje, this.desactivarEvaluacion);
      },
      desactivarEvaluacion: function () {
        //Redirige a la página SISEVA/DetallesEvaluado, para modificar la evaluación que se haya seleccionado, se envia el id de evaluación como parametro
        
        var peticion = {
          "esPrueba": false,
          "EvaluacionId": this.IdEvaluacionSeleccionada
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SISEVA.funcion.DesactivarEvaluacion, peticion).then(response => {
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
            this.buscarEvaluaciones()
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      },
      cargarDatoSolicitud: function () {
        var peticion = {
          "esPrueba": false,
          "SolicitudId": this.idSolicitud
        };
      //console.log(peticion)
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIAP.funcion.GetSolicitud, peticion).then(response => {
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
            this.Solicitud = response.data.SolicitudEvaluacion
            this.EstatusSolicitud = this.Solicitud.EstatusSolicitud
            this.FechaCreacion = this.Solicitud.FechaCreacion
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
          }).catch(e => {
            console.error("encontre un error "+e);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
          });
      },
    buscarEvaluaciones: function () { //Retorna una lista de evaluaciones pendientes en base a ciertos filtros
        //Carga la información necesaria para hacer la petición
        var peticion = {
          "esPrueba": false,
          "SolicitudId": this.idSolicitud
        };
      //console.log(peticion)
      comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIAP.funcion.GetEvaluaciones, peticion).then(response => {
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
            this.evaluaciones = response.data.Evaluaciones
            this.$nextTick(() => {
              PaginarTabla('tablaEvaluaciones', 10)
            })
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
          }).catch(e => {
            console.error("encontre un error "+e);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
          });
      },
    verDetalles: function (idEvaluacion) {
        //Redirige a la página SISEVA/DetallesEvaluado, para modificar la evaluación que se haya seleccionado, se envia el id de evaluación como parametro
        this.$router.push({
          name: 'DetalleEvaluacion',
          params: { idEvaluacion: idEvaluacion, idSolicitud: this.idSolicitud }
        })
      },
    editarPeriodoEvaluacion: function (idEvaluacion) {
        //Redirige a la página SISEVA/DetallesEvaluado, para modificar la evaluación que se haya seleccionado, se envia el id de evaluación como parametro
        this.$router.push({
          name: 'EditarPeriodoEvaluacion',
          params: { idEvaluacion: idEvaluacion, idSolicitud: this.idSolicitud }
        })
      }
    }, mounted: function () {
      this.cargarDatoSolicitud()
    this.buscarEvaluaciones()
  }

}

</script>

<style scoped>

  a {
    color: #fff;
  }

  input[type="text"]:read-only {
    background: #504f54;
  }

    input[type="text"]:read-only:focus {
      color: #fff;
    }
    .thead-custom {
      background-color: #004746;
      color: white;
    }
    .custom-area {
        background-color: #7e7f74;
    }
    .label-black {
        color: black;
    }
    .btn-custom {
        background-color: #004746;
        color: white;
    }
</style>



// WEBPACK FOOTER //
// src/components/SIAP/Evaluaciones/DetalleSolicitudEvaluacion.vue